export enum FontFamily {
  Sans = '"Helvetica Neue", Helvetica, Arial, sans-serif',
  Serif = "Georgia, serif",
}
